import request from '@/api/request';
import store from '@/views/account/redux/store';
import api_domain_config from '@/views/account/constants/common';

//api
let apiUrl = api_domain_config.API_V2_URL;

/**
 * 请求获取个人中心历史文件
 * @param {object} 请求参数
 */
const requsetGetHistoryiles = (params) => {
  let authorization = store.getState().account.authorization;
  const options = {
    ...params,
    method: 'GET',
    headers: { authorization: authorization },
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + 'history-files', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 删除历史文件
 * @param {object} 请求参数
 */
const requsetDelHistoryiles = (params) => {
  let authorization = store.getState().account.authorization;
  const options = {
    ...params,
    method: 'DELETE',
    headers: {
      authorization: authorization,
      'Content-Type': 'application/json',
    },
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + 'history-files', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const requsetGetAllType = (params) => {
  let authorization = store.getState().account.authorization;
  const options = {
    ...params,
    method: 'GET',
    headers: { authorization: authorization },
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + 'all-job-type', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const requestPurchaseUrl = (path) => {
  let authorization = store.getState().account.authorization;
  const options = {
    method: 'POST',
    headers: {
      authorization: authorization,
      'content-type': '	application/x-www-form-urlencoded',
    },
  };
  console.log(options);
  return new Promise((resolve, reject) => {
    request(apiUrl + path, options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export {
  requsetGetHistoryiles,
  requsetDelHistoryiles,
  requsetGetAllType,
  requestPurchaseUrl,
};
